/* eslint-disable */
__webpack_public_path__ = window.assetPath || '/';
/* eslint-enable */
